import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';
import { mq } from '../../theme/scalingTokens';

export const useReviewSectionStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.padding('1.25rem', '1.5rem'),
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('0.75rem'),
    boxShadow: tokens.shadow4,
    ...shorthands.borderWidth('0.125rem'),
    ...shorthands.borderStyle('solid'),
    ...shorthands.borderColor('transparent'),
    transitionProperty: 'opacity, border-color',
    transitionDuration: '0.2s',
    [mq.mobile]: {
      ...shorthands.padding('1rem'),
      ...shorthands.borderRadius('0.5rem'),
    },
  },
  /**
   * Figma 2026 ReviewSection: white surface with neutral 1 px border, 8 px
   * radius, no shadow.
   */
  rootFigma: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderRadius('0.5rem'),
    ...shorthands.padding(tokens.spacingHorizontalL),
    boxShadow: 'none',
  },
  actionable: {
    ...shorthands.borderColor(tokens.colorBrandStroke1),
  },
  locked: {
    opacity: '0.5',
    pointerEvents: 'none' as const,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '1rem',
    gap: '0.5rem',
    flexWrap: 'wrap',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  headerIcon: {
    display: 'flex',
    alignItems: 'center',
    color: tokens.colorNeutralForeground2,
    fontSize: fontScale.title,
  },
  title: {
    fontSize: fontScale.body,
    fontWeight: '600',
    color: tokens.colorNeutralForeground1,
    lineHeight: '1.25rem',
  },
  editButton: {
    fontSize: fontScale.caption,
    minWidth: 'auto',
    ...shorthands.padding('0.25rem', '0.75rem'),
  },
  grid: {
    display: 'grid',
    gap: '1rem 24px',
    [mq.mobile]: {
      gridTemplateColumns: '1fr',
      gap: '0.75rem',
    },
  },
  grid2: {
    gridTemplateColumns: '1fr 1fr',
    [mq.smallTablet]: {
      gridTemplateColumns: '1fr',
    },
  },
  grid3: {
    gridTemplateColumns: '1fr 1fr 1fr',
    [mq.tablet]: {
      gridTemplateColumns: '1fr 1fr',
    },
    [mq.mobile]: {
      gridTemplateColumns: '1fr',
    },
  },
  cell: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.125rem',
  },
  label: {
    fontSize: fontScale.caption,
    fontWeight: '600',
    color: tokens.colorNeutralForeground2,
    lineHeight: '1rem',
  },
  value: {
    fontSize: fontScale.body,
    color: tokens.colorNeutralForeground1,
    lineHeight: '1.25rem',
    wordBreak: 'break-word',
  },
});
